import React, { useEffect } from 'react';
import { Route, type RouteComponentProps } from 'react-router-dom';

// hooks
import { useMenuList, useUser } from 'hooks';

// enums
import { UserRole } from 'enums';

// const
import { ROUTE_SIGN_IN } from './const';

// services
import { COOKIE_PKG, cookieStorage } from 'services';

// libraries
import { isEmpty } from 'lodash-es';

interface ExtendedRouteProps {
  path: string;
  component: React.ComponentType<any>;
}

interface PrivateRouteProps extends ExtendedRouteProps {
  fallback: React.ComponentType<any>;
  isPermission: (role: UserRole | null) => boolean;
  exact?: boolean;
}

export const PrivateRoute = ({
  path,
  component: Component,
  fallback: Fallback,
  isPermission,
  exact = false
}: PrivateRouteProps) => {
  const { flatMenuList } = useMenuList();
  const { isLogin, userRole, userInfo, pkgNo } = useUser();

  const checkRoute = (path: string) => {
    if (!path) return false;

    const asseccibleMenu = flatMenuList.some((menu) => menu.pgmUrl === path);

    return asseccibleMenu;
  };

  useEffect(() => {
    if (!isLogin && !pkgNo && cookieStorage.getCookie(COOKIE_PKG) && !userInfo) {
      window.location.href = ROUTE_SIGN_IN;
    }
  }, [isLogin, pkgNo, userInfo]);

  if (isLogin === undefined || isEmpty(flatMenuList)) {
    return <div />;
  }

  return (
    <Route
      path={path}
      exact={exact}
      render={(props: RouteComponentProps) =>
        isPermission(userRole) ? (
          checkRoute(path) ? (
            <Component {...props} />
          ) : (
            <Fallback {...props} />
          )
        ) : (
          <Fallback {...props} />
        )
      }
    />
  );
};
